import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppSettings } from '../../../shared/app.settings';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { ToastMessageOptions } from 'primeng/api';
import { NotificationsService } from '../../services/notifications.service';
declare const google: any;

@Component({
  selector: 'app-booking-history-details',
  templateUrl: './booking-history-details.component.html'
})

export class BookingHistoryDetailsComponent implements OnInit {
  bookingId: any;
  passengerId: any;
  message: ToastMessageOptions[] = [];
  map: any;
  marker;
  maxRating = ['1', '2', '3', '4', '5'];
  sendEmailPopup = false;
  refundAmountPopup = false;
  labelBack;
  tripDetailsInfo = [];
  driverInfo = null;
  estimatesInfo = null;
  passengerInfo = null;
  vehicleInfo = null;
  invoiceInfo = null;
  tourBookingInfo = null;
  tripStatistics = [];
  fareBreakDown = [];
  tripNote: any = false;
  biddings = [];

  bookingErrors = [{
    'bookingInfo.amount': false,
    'bookingInfo.profilePassword': false
  }];

  mapImageUrl: string = AppSettings.GET_FILE_URL;
  routeImageUrl = null;
  mapView = false;
  isViewMap = false;
  markers: any = [];
  completedBookingStatus = AppSettings.COMPLETED_BOOKING_STATUS;
  expiredTrip = AppSettings.EXPIRED_BOOKING_STATUS;
  cancelledTrip = AppSettings.CANCELLED_BOOKING_STATUS;
  tourStatusActionLogs = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonBindingDataService,
    public notificationService: NotificationsService,
    
  ) { }

  ngOnInit() {
    this.bookingId = this.route.snapshot.queryParams['id'];    
    this.passengerId = this.route.snapshot.queryParams['passengerId'];

    this.labelBack = this.commonService.getLabel('label_back');
    this.tripNote = this.commonService.getTenantConfigValue(AppSettings.TRIP_NOTE);


    this.getBookingDetails();
  }

  getBookingDetails() {
    this.commonService.fetchTourBooking(this.bookingId).subscribe(results => {
      this.tripDetailsInfo = results.tripDetails;
      if (this.tripDetailsInfo) {
        this.tripDetailsInfo.splice(0, 1);
      }
      this.driverInfo = results.driverInfo;
      this.estimatesInfo = results.estimatesInfo;
      this.tourBookingInfo = results.tourBookingInfo;
      this.invoiceInfo = results.invoiceInfo;
      this.vehicleInfo = results.vehicleInfo;
      this.tripStatistics = results.tripStatistics;
      this.passengerInfo = results.passengerInfo;
      this.fareBreakDown = results.fareBreakDownList;
      this.tourStatusActionLogs = results.tourStatusActionLogs;
      if (this.invoiceInfo.staticMapImage !== undefined && this.invoiceInfo.staticMapImage !== null) {
        this.routeImageUrl = this.mapImageUrl + '/' + this.invoiceInfo.staticMapImage;
      }

      // Map loads only when user clicks "View Map" (see viewMap())
    }, (error) => {

      this.message = [];
      this.message.push({ severity: 'error', summary: 'Error Message', detail: error.general[0].message });
    });
  }

  calculateAndDisplayRoute(origin, destination, currentLocation?) {
    const mapElement = document.getElementById('tripMap');
    if (!mapElement) {
      return;
    }
    this.map = new google.maps.Map(mapElement, {
      center: origin,
      zoom: 6,
      gestureHandling: 'cooperative',
      zoomControl: true
    });

    this.setMarker(this.map, origin, 'source');
    this.setMarker(this.map, destination, 'destination');
    if (currentLocation) {
      this.setMarker(this.map, currentLocation, 'driver');
    }

    const bounds = new google.maps.LatLngBounds();
    bounds.extend(origin);
    bounds.extend(destination);
    if (currentLocation) {
      bounds.extend(currentLocation);
    }
    this.map.fitBounds(bounds);
  }

  setMarker(map, location, type) {
    let icon;
    switch (type) {
      case 'source':
        icon = '/assets/images/temp/Source.png';
        break;
      case 'destination':
        icon = '/assets/images/temp/Destination.png';
        break;
      default:
        icon = '/assets/images/temp/taxi_free.png';
        break;
    }
    this.marker = new google.maps.Marker();
    this.marker.setMap(map);
    this.marker.setIcon(icon);
    this.marker.setPosition(location);
    this.markers.push(this.marker);
  }

  viewMap() {
    if (!this.tourBookingInfo) {
      return;
    }
    this.isViewMap = true;
    this.mapView = true;
    const origin = {
      lat: this.tourBookingInfo.sourceLatitude,
      lng: this.tourBookingInfo.sourceLongitude,
    };
    const destination = {
      lat: this.tourBookingInfo.destinationLatitude,
      lng: this.tourBookingInfo.destinationLongitude
    };
    setTimeout(() => this.calculateAndDisplayRoute(origin, destination), 0);
  }

  onClickBack() {
    this.router.navigate(['passengers/passenger-details'], { queryParams: { passengerId: this.passengerId } });
  }

  mapMessage(status) {
    this.message = [];
    this.message.push({ severity: 'success', summary: 'Confirmed', detail: status });
  }
}



